import React from "react";
import { Drawer, Button, Space, Switch, Divider } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import DPCard from "./DPCard";
import "./PincodeDetailsDrawer.scss";

const PincodeDetailsDrawer = ({ visible, onClose, pincodeData }) => {
  if (!pincodeData) return null;

  // Transform API response DPs to component format
  const transformedDPs = pincodeData.dps ? pincodeData.dps.map((dp, index) => ({
    id: dp.dpId?.toString() || index.toString(),
    name: dp.dpName || "Unknown DP",
    dpId: dp.dpId?.toString() || "",
    type: dp.dpType || "Unknown",
    status: true, // Assuming active if in response
    fmHub: dp.FM_hub?.name || "",
    lmHub: dp.LM_hub?.name || "",
    fmHubId: dp.FM_hub?.premise_id || "",
    lmHubId: dp.LM_hub?.premise_id || "",
    services: dp.business_types || []
  })) : [];


  // const renderServiceTags = (services) => {
  //   return (
  //     <Space size={4} wrap>
  //       {services.map(service => (
  //         <Tag 
  //           key={service} 
  //           className={`service-tag ${service.toLowerCase().replace(" ", "-")}`}
  //         >
  //           {service}
  //         </Tag>
  //       ))}
  //     </Space>
  //   );
  // };

  return (
    <Drawer
      title="Pincode Details"
      placement="right"
      onClose={onClose}
      visible={visible}
      width={720}
      className="pincode-details-drawer"
      closeIcon={<CloseOutlined />}
    >
      <div className="drawer-content">
        {/* Pincode Info Section */}
        <div className="pincode-info-section">
          <div className="info-grid">
            <div className="info-row">
              <div className="info-item">
                <label>Pincode</label>
                <span className="value">{pincodeData.pincode}</span>
              </div>
              <div className="info-item">
                <label>City</label>
                <span className="value">{pincodeData.city}</span>
              </div>
            </div>
            <div className="info-row">
              <div className="info-item">
                <label>State</label>
                <span className="value">{pincodeData.state}</span>
              </div>
              <div className="info-item">
                <label>Status</label>
                <Switch
                  checked={pincodeData.status}
                  disabled
                  className="status-switch"
                  size="small"
                />
              </div>
            </div>
          </div>
        </div>

        <Divider className="section-divider" />

        {/* DPs Section */}
        <div className="dps-section">
          <div className="section-header">
            <h3>Delivery Partners</h3>
            {/* <Button
              type="primary"
              ghost
              icon={<EditOutlined />}
              onClick={handleEdit}
              className="assign-dp-btn"
            >
              ASSIGN DP
            </Button> */}
          </div>

          <div className="dp-cards">
            {transformedDPs.length > 0 ? (
              transformedDPs.map((dp) => (
                <div key={dp.id} className="dp-card-wrapper">
                  <DPCard
                    dp={dp}
                    onUpdate={() => {}} // Read-only in drawer
                    onRemove={() => {}} // Read-only in drawer
                    readOnly={true}
                  />
                </div>
              ))
            ) : (
              <div className="no-dps">
                <p>No Delivery Partners Assigned to this Pincode</p>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Drawer Footer */}
      <div className="drawer-footer">
        <Space>
          <Button onClick={onClose} className="close-btn">
            Close
          </Button>
          {/* <Button
            type="primary"
            onClick={handleEdit}
            className="update-btn"
          >
            Update
          </Button> */}
        </Space>
      </div>
    </Drawer>
  );
};

export default PincodeDetailsDrawer;
